import { Component, EventEmitter, Output, ViewEncapsulation, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MessageTemplateService, CreateTemplateRequest, MessageTemplate } from '../../core/services/message-template.service';
import { SessionService } from '../../core/session.service';

@Component({
  selector: 'app-template-create-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './template-create-modal.component.html',
  styleUrls: ['./template-create-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class TemplateCreateModalComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
    document.body.classList.add('modal-open');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('modal-open');
  }

  @Output() close = new EventEmitter<void>();
  @Output() created = new EventEmitter<MessageTemplate>();

  private fb = inject(FormBuilder);
  private templateService = inject(MessageTemplateService);
  private session = inject(SessionService);
  private translate = inject(TranslateService);

  loading = false;
  errorMsg = '';

  form = this.fb.nonNullable.group({
    name: ['', Validators.required],
    subject: [''],
    content: ['', Validators.required],
  });

  submit(): void {
    if (this.loading || this.form.invalid) return;
    
    const selectedId = this.session.selectedId();
    const establishment = this.session.establishments().find(e => e.id === selectedId);
    if (!establishment?.org_id) {
      this.errorMsg = this.translate.instant('componentsWizard.templateCreate.errorOrgNotFound');
      return;
    }

    this.loading = true;
    this.errorMsg = '';

    const raw = this.form.getRawValue();
    const payload: CreateTemplateRequest = {
      organisationId: establishment.org_id,
      name: raw.name.trim(),
      subject: raw.subject.trim() || undefined,
      content: raw.content.trim(),
      type: 'EMAIL_REPLY'
    };

    this.templateService.createTemplate(payload).subscribe({
      next: (template: MessageTemplate) => {
        this.created.emit(template);
        this.close.emit();
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.errorMsg = err?.error?.message || this.translate.instant('componentsWizard.templateCreate.errorDefault');
      },
    });
  }

  onClose(): void {
    if (!this.loading) this.close.emit();
  }
}